// extracted by mini-css-extract-plugin
export default {"hero":"heroSection_hero__FJ5bF","heroContent":"heroSection_heroContent__Ch8uc","downloadBtns":"heroSection_downloadBtns__d2SGo"};